module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "headers": {
        'fitness-appId': '2001'
      },
      "with-credentials": "",
      "action": _vm.action,
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess
    }
  }, [(_vm.value) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.value
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14ca64f9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageUpload.vue
// module id = 1109
// module chunks = 2